<template>
  <button @click="openInfo()" class="btn btn-help">
    <span class="ti-help-alt"></span>
  </button>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Info",
  props: {
    id: {
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    openInfo() {
      let query = Object.assign({}, this.$route.query);
      if (query["item_get_info"] == this.id) {
        return false;
      }

      if (query["item_get_info"]) {
        delete query["item_get_info"];
      }

      query["item_get_info"] = this.id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
};
</script>
